/**
 *
 * @author fuyg
 * @date  2020-06-03
 */

import React, { ReactElement /*, useEffect */ } from 'react'
// import { useSelector, useDispatch, shallowEqual } from 'react-redux'
// import styles from './NewsView.module.scss'
// import { fetchData } from '../sliceName'
// import { RootState } from 'src/pages/home/store/rootReducer'
// import { renderRoutes, RouteConfigComponentProps } from 'react-router-config'
import { RecentNewsArticle } from 'src/pages/home/components/RecentNewsArticle'

function NewsView(): ReactElement {
  // 获取数据
  // const dispatch = useDispatch()

  // useEffect(() => {
  // dispatch(fetchData({}))
  // }, [])

  // 绑定数据
  // const { data } = useSelector((state: RootState) => {
  // return {
  // data: state.sliceName.data,
  // }
  // }, shallowEqual)

  // TODO

  return <RecentNewsArticle />
}

export default NewsView
